export default __webpack_public_path__ + "static/simulation-banner-d05791897170a4c9de3146dbafc3674e.png";